// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V-u7","type":"styles_type__2_dZM","choices":"styles_choices__3xegw"};